import Table from '@/common/components/Table';
import { getHeadersArray } from './helpers/getHeadersArray';
import { getRaws } from './helpers/getRaws';

const PreResultTable = ({ payment, consultantResults, reloadData }) => (
	<Table
		style={{ marginTop: '30px' }}
		raws={getRaws(payment, consultantResults)}
		headersArray={getHeadersArray(payment.is_final, () =>
			reloadData(payment._id),
		)}
		className='styled-table'
	/>
);
export default PreResultTable;
